module.exports = __webpack_public_path__ + "static/editorsnote-451c5fbad8044693adf362161a54dea7.mp3";